import { keyWords, languagesWithSpaces, languagesWithoutSpaces } from './key-words.ts';

type queryProcessorArgs = {
	query: string;
	locale: string;
};

export const queryProcessor = ({ query, locale }: queryProcessorArgs): string => {
	const language = locale.split('-')[0].toLowerCase();
	const stopWords = keyWords[language];

	const text = query.replace(/[.,\/#!$?%\^&\*;:{}=\-_`~()]/g, '');

	if (languagesWithoutSpaces.includes(language)) {
		const processedQuery = stopWords.reduce((result, word) => result.replace(word, ''), text);
		return processedQuery;
	}

	if (languagesWithSpaces.includes(language)) {
		const lowerText = text.toLocaleLowerCase(locale);
		const queryWords = lowerText.split(' ');
		const processedQuery = queryWords.filter((word) => !stopWords.includes(word)).join(' ');
		return processedQuery;
	}

	return query;
};
